import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { makeStyles } from '@material-ui/core/styles';
import { Avatar, CircularProgress, TextField, Grid, IconButton } from '@material-ui/core';
import SendIcon from '@mui/icons-material/Send';
import * as editNoteActions from '../../../redux/actions/notes';
import { createNotes } from '../../../helpers/api';

const styles = makeStyles(() => ({
  pricingFlexContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
  },
  buttonContainer: {
    alignItems: 'flex-end',
    marginTop: 11,
  },
  addButton: {
    backgroundColor: '#9c27b0',
    color: '#9c27b0',
    '&:hover': {
      color: '#BA68C8',
      backgroundColor: '#BA68C8',
    },
    '&:disabled': {
      backgroundColor: '#9c27b0',
      color: '#9c27b0',
    },
  },
  instructionsP: {
    textAlign: 'center',
    width: '100%',
    marginBottom: '-10px',
    fontSize: '12px',
  },
}));

const NoteAdd = props => {
  const { entityType, entityID, noteType, sourceType, eventActions, isLoading, setIsLoading } = props;
  const classes = styles();
  const [currNote, setNote] = useState('');

  const handleChange = event => {
    setNote(event.target.value);
  };

  const handleNoteEditSubmit = async event => {
    event.preventDefault();
    setIsLoading(true);
    await createNotes({
      sourceType,
      entityType,
      entityID,
      noteType,
      userVersion: 0,
      note: currNote,
    });
    const notesResponse = await editNoteActions.fetchNotesApi(entityType, entityID);
    eventActions.notesReceived(notesResponse);
    setNote('');
    setIsLoading(false);
  };

  return (
    <Grid container direction="row" justifyContent="space-between">
      <Grid item xs={11}>
        <TextField id="standard-basic" label="Add note" multiline fullWidth onChange={handleChange} value={currNote} />
      </Grid>
      <Grid item xs={1} className={classes.buttonContainer}>
        {isLoading ? (
          <CircularProgress size={30} />
        ) : (
          <IconButton
            size="small"
            color="primary"
            disabled={!(currNote.length > 0) || isLoading}
            onClick={handleNoteEditSubmit}
            className={classes.addButton}
          >
            <Avatar style={{ background: 'transparent', width: 30, height: 30 }} aria-label="Send">
              <SendIcon style={{ color: 'white' }} fontSize="small" />
            </Avatar>
          </IconButton>
        )}
      </Grid>
    </Grid>
  );
};

NoteAdd.propTypes = {
  entityID: PropTypes.string.isRequired,
  entityType: PropTypes.string.isRequired,
  eventActions: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  noteType: PropTypes.string.isRequired,
  setIsLoading: PropTypes.func.isRequired,
  sourceType: PropTypes.string.isRequired,
};

const mapDispatchToProps = dispatch => ({ eventActions: bindActionCreators(editNoteActions, dispatch) });

export default connect(null, mapDispatchToProps)(NoteAdd);
